import Vue from 'vue';
import { BookingMealOption } from '@/constants/mealOption';
import { PaymentMethods } from '@/constants/paymentMethods';
import { RatePlanInterface } from '@/types/store/landing/hotels/roomDataInterface';

Vue.mixin({
  methods: {
    filterRatePlan(
      ratePlans: RatePlanInterface[],
      mealOption: BookingMealOption,
      paymentMethod: PaymentMethods,
    ): RatePlanInterface[] {
      return ratePlans.filter(
        (x: RatePlanInterface) => x.meal_options.length === mealOption && x.guarantee_type === paymentMethod,
      );
    },
  },
});
